import styled from 'styled-components';
import { FONTS, COLORS } from '@ertelecom/ui-react/assets/js/constants';

export const Wrapper = styled.div`
    display: block;
    margin-right: 108px;
    margin-bottom: 20px;
    &:last-child {
        margin-right: 0;
    }
    @media (max-width: 1279px) {
        margin-right: 80px;
    }
    @media screen and (max-width: 859px) {
        display: flex;
        justify-content: flex-start;
        align-items: center;
    }
`;

export const Icon = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    width: 58px;
    height: 58px;
    margin-bottom: 10px;
    svg {
        display: block;
        width: 100%;
        max-width: 100%;
        max-height: 100%;
    }
    path {
        fill: ${p => p.textColor ? p.textColor : COLORS.black};
        stroke: ${p => p.textColor ? p.textColor : COLORS.black};
    }
    @media (max-width: 1279px) {
        width: 40px;
        height: 40px;
    }
    @media screen and (max-width: 859px) {
        margin-bottom: 0;
    }
`;

export const Text = styled.div`
    display: block;
    color: ${p => p.textColor ? p.textColor : COLORS.black};
    font-size: 16px;
    line-height: 1.33;
    font-family: ${FONTS.regular};
    @media (max-width: 1279px) {
        font-size: 14px;
    }
    @media screen and (max-width: 859px) {
        padding-left: 12px;
    }
`;
